export const defaultHaynesLanguagesForCountry = (country: string) => {
  switch (country.toLowerCase()) {
    case 'nl':
      return ['NL', 'UK']
    case 'be':
      return ['NL', 'FR']
    case 'de':
      return ['DE', 'UK']
    case 'fr':
      return ['FR', 'UK']
    case 'cz':
      return ['CZ', 'DE']
    case 'ch':
      return ['DE', 'FR']
    case 'pl':
      return ['PL', 'DE']
    case 'it':
      return ['IT', 'FR']
    case 'es':
      return ['ES', 'UK']
    case 'UK':
      return ['UK', 'ES']

    default:
      return ['UK']
  }
}

export const haynesLanguageOptions = [
  { text: 'DE', key: 'DE', value: 'DE' },
  { text: 'NL', key: 'NL', value: 'NL' },
  { text: 'EL', key: 'EL', value: 'EL' },
  { text: 'IT', key: 'IT', value: 'IT' },
  { text: 'CS', key: 'CS', value: 'CS' },
  { text: 'PT', key: 'PT', value: 'PT' },
  { text: 'FR', key: 'FR', value: 'FR' },
  { text: 'PL', key: 'PL', value: 'PL' },
  { text: 'NO', key: 'NO', value: 'NO' },
  { text: 'FI', key: 'FI', value: 'FI' },
  { text: 'SL', key: 'SL', value: 'SL' },
  { text: 'HU', key: 'HU', value: 'HU' },
  { text: 'RO', key: 'RO', value: 'RO' },
  { text: 'ES', key: 'ES', value: 'ES' },
  { text: 'EN', key: 'EN', value: 'EN' },
  { text: 'DA', key: 'DA', value: 'DA' },
  { text: 'RU', key: 'RU', value: 'RU' },
  { text: 'TR', key: 'TR', value: 'TR' },
  { text: 'SV', key: 'SV', value: 'SV' },
  { text: 'BG', key: 'BG', value: 'BG' },
  { text: 'SK', key: 'SK', value: 'SK' },
  { text: 'SR', key: 'SR', value: 'SR' },
  { text: 'HR', key: 'HR', value: 'HR' },
  { text: 'LV', key: 'LV', value: 'LV' },
  { text: 'LT', key: 'LT', value: 'LT' },
  { text: 'ET', key: 'ET', value: 'ET' },
  { text: 'UK', key: 'UK', value: 'UK' }
]

export const QueryParamAllShops = {
  key: 'allShops'
}
